export const USER_PLATFORM_ROUTE_PREFIX = '/profile/'

export function isUserPlatformRoute(path: string): boolean {
  return path.startsWith(USER_PLATFORM_ROUTE_PREFIX)
}

export function notifyUserPlatformRouter(): void {
  window.dispatchEvent(new PopStateEvent('popstate'))
}

export function removeSalesDashboardAppCss(): void {
  document.getElementById('sales-dashboard-app-css')?.remove()
}
